export default __webpack_public_path__ + "static/media/auteur2.d02782fe.png";